export const COST_UP_COLOR = '#FFCC00';
export const COST_DOWN_COLOR = '#e81123';
export const PRICE_UP_COLOR = '#16A34A';
export const PRICE_DOWN_COLOR = '#e81123';

export function safeParsePrice(val) {
    if (val === null || val === undefined || val === '') {
        return null;
    }
    const parsed = parseFloat(val);
    return Number.isNaN(parsed) ? null : parsed;
}

export function getHighlightTextColor(highlightColor) {
    if (highlightColor === COST_UP_COLOR) {
        return '#333333';
    }
    return '#ffffff';
}

export function getCostHighlightColor(newCost, currentCost) {
    const cur = safeParsePrice(currentCost);
    const value = safeParsePrice(newCost);
    if (cur == null || cur <= 0 || value == null) {
        return null;
    }
    if (value.toFixed(2) === cur.toFixed(2)) {
        return null;
    }
    if (value > cur) {
        return COST_UP_COLOR;
    }
    return COST_DOWN_COLOR;
}

export function getPriceBaseline(rowData) {
    const curPrice = safeParsePrice(rowData?.oldPrice);
    if (curPrice != null && curPrice > 0) {
        return curPrice;
    }
    return safeParsePrice(rowData?.recommendedSalePrice);
}

export function getPriceHighlightColor(value, baseline) {
    const parsedValue = safeParsePrice(value);
    const parsedBaseline = safeParsePrice(baseline);
    if (parsedValue == null || parsedBaseline == null) {
        return null;
    }
    if (parsedValue.toFixed(2) === parsedBaseline.toFixed(2)) {
        return null;
    }
    if (parsedValue > parsedBaseline) {
        return PRICE_UP_COLOR;
    }
    return PRICE_DOWN_COLOR;
}

export function getPurchaseOrderFieldHighlight(rowData, field, value) {
    if (!rowData || !field) {
        return null;
    }

    const fieldValue = value !== undefined ? value : rowData[field];

    if (field === 'oldPrice') {
        return null;
    }

    if (field === 'unitCost') {
        return getCostHighlightColor(fieldValue, rowData.currentUnitCost);
    }

    if (field === 'recommendedSalePrice' || field === 'salePrice') {
        return getPriceHighlightColor(fieldValue, getPriceBaseline(rowData));
    }

    return null;
}

export function getPurchaseOrderHighlightStyle(highlightColor) {
    if (!highlightColor) {
        return null;
    }
    return {
        backgroundColor: highlightColor,
        color: getHighlightTextColor(highlightColor),
        padding: '2px 4px',
        borderRadius: '2px',
        display: 'inline-block'
    };
}

export function isPurchaseOrderFieldUp(highlightColor) {
    return highlightColor === COST_UP_COLOR || highlightColor === PRICE_UP_COLOR;
}
